import { Alert, Snackbar, SnackbarOrigin } from '@mui/material'
import React from 'react'

type Props = {
    open: boolean;
    text?: string;
}
interface State extends SnackbarOrigin {
    open: boolean;
}
const SnackBarCustom: React.FC<Props> = ({ text, open }: Props) => {
    const [state, setState] = React.useState<State>({
        open,
        vertical: 'bottom',
        horizontal: 'right',
    });
    const { vertical, horizontal } = state;
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity="success"
                variant="filled"
                sx={{ width: '100%' }}
            >
                {text}
            </Alert>
        </Snackbar>
    )
}

export default SnackBarCustom